// @ts-check

/** @file Adds the catalog-owned registry for retained per-project replicas. */

import Migration from "velocious/build/src/database/migration/index.js"

/** Creates the lightweight catalog registry and project routing-epoch field. */
export default class CreateProjectReplicaRegistry extends Migration {
  /** Creates catalog-owned metadata without touching retained legacy replica rows. */
  async up() {
    await this.createTable("project_replica_registry_entries", {id: {type: "uuid"}}, (table) => {
      table.uuid("user_id", {null: false})
      table.uuid("project_id", {null: false})
      table.bigint("routing_epoch", {null: false})
      table.string("physical_name", {null: false})
      table.string("state", {default: "sealed", null: false})
      table.datetime("last_opened_at", {null: true})
      table.timestamps({null: false})
    })
    await this.addIndex("project_replica_registry_entries", ["user_id", "project_id"], {unique: true})
    await this.addIndex("project_replica_registry_entries", ["physical_name"], {unique: true})
    await this.addIndex("project_replica_registry_entries", ["user_id", "state"])

    await this.addColumn("projects", "routing_epoch", "bigint", {null: true})
  }

  /** Removes only the catalog registry and routing metadata. */
  async down() {
    await this.removeColumn("projects", "routing_epoch")
    await this.removeTable("project_replica_registry_entries")
  }
}
